import React from 'react'
import { useMatch } from 'react-router'
import { useIntl } from 'react-intl'

import NavLink from './Link'
import { OfficeIcon, ChevronIcon } from '../Icon'
import { Divider } from './Primary'
import { useSession } from '../../providers/SessionProvider'
import useBreakpoint from '../../hooks/useBreakpoint'

const OrganisationLink = ({ orgId }) => {
  const { can, currentOrganisationId, memberships } = useSession({
    orgId
  })
  const aboveMobile = useBreakpoint(0)
  const aboveTablet = useBreakpoint(1)

  const showFullLink = memberships.length > 1 ? aboveTablet : aboveMobile

  const matchOrganisations = useMatch('/organisations/*', {
    end: false
  })

  const { formatMessage } = useIntl()

  if (currentOrganisationId && can('updateOrganisations')) {
    const LINK_TITLE = formatMessage({ id: `navigation.links.organisation.${matchOrganisations ? 'back' : 'label'}` })
    return (
      <>
        <NavLink
          title={LINK_TITLE}
          to={
            matchOrganisations
              ? `/organisations/${currentOrganisationId}` // Handled by OrganisationIndex
              : `/organisations/${currentOrganisationId}/members`
          }
          variant="navPrimary"
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 0
          }}
        >
          {matchOrganisations ? (
            <ChevronIcon verticalAlign="middle" mr={showFullLink ? '8px' : 0} rotate="90deg" color="blue100" />
          ) : (
            <OfficeIcon verticalAlign="middle" mr={showFullLink ? '8px' : 0} color="blue100" />
          )}
          {showFullLink ? LINK_TITLE : null}
        </NavLink>
        <Divider ml="15px" />
      </>
    )
  }
  return null
}

export default OrganisationLink
